import { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Fallback defaults used before the API response arrives or when offline.
export const DEFAULT_CONTENT = {
  hero_eyebrow: "01 · August · 2026",
  hero_names: "Nico & Nicole",
  hero_tagline: "Wir heiraten",
  hero_subtitle: "Samstag, 13:00 Uhr · Gut Haferkorn",
  hero_cta: "Jetzt zusagen",
  hero_image: "https://cloud.nhaage.de/index.php/apps/files_sharing/publicpreview/dxs2C3AMqtFKr5D?file=/20260430-120349_hero_custom.jpeg&x=2400&y=2400&a=1",

  story_eyebrow: "· Kapitel Eins ·",
  story_title_prefix: "Unsere",
  story_title_script: "Geschichte",
  story_p1: "Kennengelernt haben wir uns dort, wo unser Herz am lautesten schlägt — in unserer Motorrad-Gruppe. Gemeinsame Touren, laute Motoren, leise Blicke. Zwischen Serpentinen und Sonnenuntergängen hat sich etwas angebahnt, das wir beide zuerst gar nicht so recht in Worte fassen konnten.",
  story_p2: "Und dann kam der Moment, der alles veränderte: Eine Verletzung — und plötzlich war da dieses Gefühl, das stärker war als jeder Geschwindigkeitsrausch. Aus \"Kumpels auf zwei Rädern\" wurde ein Wir. Aus einem Wir wurde ein Zuhause.",
  story_p3: "Jetzt wagen wir den nächsten großen Ritt — und dieser geht für immer. Wir freuen uns riesig, diesen Tag mit euch zu feiern.",
  story_image: "https://cloud.nhaage.de/index.php/apps/files_sharing/publicpreview/dxs2C3AMqtFKr5D?file=/20260430-120324_story_motorrad.jpeg&x=1600&y=1600&a=1",

  timeline_eyebrow: "· Der Ablauf ·",
  timeline_title_prefix: "Der",
  timeline_title_script: "Zeitplan",
  timeline_subtitle: "Damit ihr keinen Moment verpasst — hier der Fahrplan für unseren großen Tag.",
  timeline_events: [
    { time: "13:00", icon: "wine", title: "Ankunft", description: "Um keine unangenehme Stimmung hervorzurufen, seid bitte bis spätestens 13:45 Uhr vor Ort." },
    { time: "14:00", icon: "heart", title: "Trauung", description: "Der emotionale Start in unseren großen Tag." },
    { time: "15:00", icon: "wine", title: "Sekt-Empfang", description: "Gemeinsames Anstoßen auf die Liebe." },
    { time: "16:00", icon: "cake", title: "Geschichte Gut Haferkorn & Kuchen", description: "Kleine Führung und Tortenanschnitt für alle, die mögen." },
    { time: "17:30", icon: "tent", title: "Zelteröffnung", description: "Die Festlocation wird feierlich eröffnet." },
    { time: "19:00", icon: "utensils", title: "Abendessen", description: "Gemeinsames Dinner in festlicher Runde." },
    { time: "20:00", icon: "music", title: "Eröffnung der Tanzfläche", description: "Party bis open end!" },
  ],

  location_eyebrow: "· Location ·",
  location_title_prefix: "Gut",
  location_title_script: "Haferkorn",
  location_description: "Unsere Feier findet auf dem wunderschönen Gut Haferkorn statt — einem idyllischen Ort mit rustikalem Charme, eingebettet in die sanfte sächsische Landschaft.",
  location_date_main: "01. August 2026 · Ankunft ab 13:00 Uhr",
  location_date_sub: "Samstag · Trauung um 14:00 Uhr",
  location_directions_title: "Wegbeschreibung",
  location_directions: [
    "Nutzt die Autobahnabfahrt Leisnig (A14) — das ist der schnellste Weg zu uns.",
    "Folgt der Beschilderung in Richtung Leisnig / Gut Haferkorn.",
    "Nach wenigen Minuten Landstraße erreicht ihr das Gut. Parkplätze sind vor Ort ausreichend vorhanden.",
  ],
  location_image: "https://cloud.nhaage.de/index.php/apps/files_sharing/publicpreview/dxs2C3AMqtFKr5D?file=/20260430-120050_gut_haferkorn_luftaufnahme.jpeg&x=2400&y=2400&a=1",
  location_maps_url: "https://www.google.com/maps/search/?api=1&query=Gut+Haferkorn+Leisnig",

  hotel_eyebrow: "· Übernachtung ·",
  hotel_title_prefix: "Direkt vor Ort",
  hotel_title_script: "schlafen",
  hotel_description: "Das Gut Haferkorn bietet 27 eigene Zimmer direkt auf dem historischen Vierseitenhof. Kein Taxi, keine lange Heimfahrt — einfach feiern und am nächsten Morgen gemütlich frühstücken.",
  hotel_details: "Alle Zimmer mit Bad, WLAN und Schreibtisch · Check-in ab 12:00 Uhr · Frühstücksbuffet, Parkplatz und MwSt. inklusive.",
  hotel_cta: "Lass uns im RSVP wissen, ob ihr ein Zimmer möchtet — wir kümmern uns um die Reservierung.",
  hotel_rooms: [
    { name: "Einzelzimmer", price: "86 €", detail: "22 Zimmer · 13–19 m²" },
    { name: "Doppelzimmer", price: "138 €", detail: "1 Doppelzimmer · 2 Personen · 13–19 m²" },
    { name: "Einzelzimmer mit Aufbettung", price: "122 €", detail: "Twin · 2 Personen" },
    { name: "Ferienwohnung", price: "238 €", detail: "" },
  ],
  hotel_rooms_footnote: "pro Nacht · inkl. Frühstück",
  hotel_link_url: "https://www.gut-haferkorn.de/uebernachten/",
  hotel_link_label: "Alle Zimmer auf gut-haferkorn.de ansehen",

  rsvp_eyebrow: "· Zusage ·",
  rsvp_title_prefix: "Save the",
  rsvp_title_script: "Date",
  rsvp_description: "Wir würden uns freuen, wenn ihr mit uns feiert. Bitte gebt uns bis spätestens {deadline} Bescheid.",
  rsvp_deadline: "30. Juni 2026",
};

const ContentContext = createContext({
  content: DEFAULT_CONTENT,
  loading: true,
  reload: async () => {},
});

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/content`);
      setContent({ ...DEFAULT_CONTENT, ...(data || {}) });
    } catch (e) {
      setContent(DEFAULT_CONTENT);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <ContentContext.Provider value={{ content, loading, reload: load }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
